import axios from '@/axios';

const RESOURCE_NAME = '/markets';

export default {
    getSectorsList() {
        return axios.get(`${RESOURCE_NAME}/get-sectors-list`)
    },

    getCombinedSectorsList() {
        return axios.get(`${RESOURCE_NAME}/get-combined-sectors-list`)
    },

    getReport(subsectorName, read) {
        return axios.get(`${RESOURCE_NAME}/get-report`, {
            params: {
                subsector_name: subsectorName,
                read: read,
            },

            responseType: 'blob',
        });
    },

    getPartnershipsIndex(pageParams) {
        return axios.post(`${RESOURCE_NAME}/get-partnerships-index`, pageParams);
    },

    getUpdates(filters) {
        return axios.post(`${RESOURCE_NAME}/get-updates`, {filters})
    },

    getSubscription(subsectorId) {
        return axios.get(`${RESOURCE_NAME}/get-subscription?subsectorId=${subsectorId}`);
    },

    subscribe(subsectorId, subscribe) {
        return axios.post(`${RESOURCE_NAME}/subscribe?subsectorId=${subsectorId}`, {subscribe});
    },

    getReports(creator, pageParams) {
        return axios.post(`${RESOURCE_NAME}/get-reports?creator=${creator}`, pageParams);
    },

    searchPartnershipCorporates(query) {
        return axios.get(`${RESOURCE_NAME}/search-partnership-corporates?query=${query}`);
    },

    searchPartnershipStartups(query) {
        return axios.get(`${RESOURCE_NAME}/search-partnership-startups?query=${query}`);
    },

    getMostFrequentStartupsList() {
        return axios.get(`${RESOURCE_NAME}/get-most-frequent-startups-list`);
    },

    getMostFrequentCorporatesList() {
        return axios.get(`${RESOURCE_NAME}/get-most-frequent-corporates-list`);
    },
}
